import { Applicant } from '../applicant';
import { ViewScheduledInterview } from '../viewScheduledInterview';


export class ViewScheduledInterviewSerializer {
    fromJson(json: any): ViewScheduledInterview {
        if(json && json.length>0 && json[0].searchDto && json[0].searchDto.applicant &&json[0].searchDto.applicant.length>0){
            for(let i=0; i<json[0].searchDto.applicant.length;i++){
                const applicantData = new Applicant();
                applicantData.id = json[0].searchDto.applicant[i].id;
                if(json[0].searchDto.applicant[i].lastName){
                    applicantData.name= json[0].searchDto.applicant[i].firstName + ' ' + json[0].searchDto.applicant[i].lastName + ' - ' + transfromPhoneNumber(json[0].searchDto.applicant[i].phone);
                }
                else{
                    applicantData.name= json[0].searchDto.applicant[i].firstName + ' - ' + transfromPhoneNumber(json[0].searchDto.applicant[i].phone);
                }
                applicantData.firstName =json[0].searchDto.applicant[i].firstName;
                applicantData.lastName=json[0].searchDto.applicant[i].lastName;
                applicantData.email=json[0].searchDto.applicant[i].email;
                applicantData.phone=json[0].searchDto.applicant[i].phone;
                applicantData.fullName=json[0].searchDto.applicant[i].lastName? json[0].searchDto.applicant[i].firstName + ' ' + json[0].searchDto.applicant[i].lastName : json[0].searchDto.applicant[i].firstName;
                json[0].searchDto.applicant[i]=applicantData;
            }
        }
        return json;
    }

    toJson(data: ViewScheduledInterview): any {
        return {
            startTime: data.startTime,
            statusId: data.statusId,
            applicantId: data.applicantId,
            jobId: data.jobId,
            interviewStepMapping:data.interviewStatus
            // .map(function (val) {
            //   return {id: val }  
            // })
                // {
                // interviewStep: data.interviewStepMapping.interviewStep,
                // user: data.interviewStepMapping.user,
                // notes: data.interviewStepMapping.notes,
                // pass: data.interviewStepMapping.pass,
                // interviewStepStatus: data.interviewStepMapping.interviewStepStatus,
                // comment: data.interviewStepMapping.comment
                // }
        };
    }
}
function transfromPhoneNumber(phone: any) {
    //const countryCodeStr = phone.slice(0,2);
    const areaCodeStr = phone.slice(0,3);
    const midSectionStr = phone.slice(3,6);
    const lastSectionStr = phone.slice(6);

    return `${areaCodeStr}-${midSectionStr}-${lastSectionStr}`;
}
